const settings = {
  title: 'Einstellungen',
  subtitle: 'Konfiguriere deine Konto- und Plattformpräferenzen',
  categoriesTitle: 'Einstellungs-Kategorien',
  badges: {
    comingSoon: 'Kommt bald',
    restricted: 'Eingeschränkt',
  },
  statusLabels: {
    configured: 'Konfiguriert',
    incomplete: 'Unvollständig',
    pending: 'Nicht konfiguriert',
  },
  sections: {
    profile: {
      title: 'Profil-Einstellungen',
      description: 'Verwalte deine Kontoinformationen und Kontaktdaten',
      placeholderTitle: 'Profil-Einstellungen werden hier implementiert.',
      placeholderDescription:
        'Enthält zukünftig Kontoinformationen, Kontaktdaten und Profilaktualisierungen.',
    },
    organization: {
      title: 'Organisationseinstellungen',
      description: 'Unternehmensinformationen und Teamverwaltung',
      placeholderTitle: 'Organisationseinstellungen werden hier implementiert.',
      placeholderDescription:
        'Enthält zukünftig Unternehmensinformationen und Team-Mitgliederverwaltung.',
    },
    stripe: {
      title: 'Stripe-Konfiguration',
      description: 'Richte die Zahlungsabwicklung mit Stripe ein',
    },
    socialAuth: {
      title: 'Social Login',
      description: 'Verwalte OAuth-Anbieter für Google, GitHub, Apple und Microsoft',
    },
    signupRedirect: {
      title: 'Signup-Redirect',
      description: 'Leite Self-Service-Anmeldungen nach der Kontoerstellung weiter',
    },
    providerPassword: {
      title: 'Passwort-Anmeldung (Provider)',
      description: 'Aktiviere Passwortanmeldung und Richtlinien für Provider-Benutzer.',
    },
    customerPassword: {
      title: 'Passwort-Anmeldung (Kunden)',
      description: 'Steuere, ob Kunden sich mit Passwort anmelden können.',
    },
    integrations: {
      title: 'Integrationen',
      description: 'Verbinde externe Plattformen und Automationsziele.',
    },
    general: {
      title: 'Allgemein',
      description: 'Grundlegende Kontoeinstellungen und rechtliche Links.',
    },
    portalMenu: {
      title: 'Kundenportal-Menü',
      description: 'Füge benutzerdefinierte Links zur Kundenportal-Navigation hinzu.',
    },
    checkout: {
      title: 'Checkout',
      description: 'Konfiguriere Checkout-Text, Felder und Domains.',
    },
    branding: {
      title: 'Branding & White-Label',
      description: 'Passe deine kundenseitige Experience an',
    },
    notifications: {
      title: 'Benachrichtigungspräferenzen',
      description: 'Steuere Plattform-Benachrichtigungen und Alerts',
    },
    apiAccess: {
      title: 'Provider-API-Zugriff',
      description: 'Verwalte API-Tokens und Webhook-Konfigurationen',
    },
    testMode: {
      title: 'Testmodus',
      description: 'Teste API-Produkte, bevor sie live gehen',
    },
  },
  account: 'Konto',
  preferences: 'Einstellungen',
  security: 'Sicherheit',
  notifications: 'Benachrichtigungen',
  signupRedirect: {
    title: 'Signup-Redirect',
    description: 'Steuere, wohin sich selbstregistrierte Kunden nach der Anmeldung begeben.',
    fields: {
      enabled: 'Redirect aktivieren',
      url: 'Redirect-URL',
      verificationEnabled: 'Redirect nach Verifizierung aktivieren',
      verificationUrl: 'Redirect-URL nach Verifizierung',
    },
    helpers: {
      enabled:
        'Gilt nur für nicht authentifizierte Self-Service-Signups. Von Providern angelegte Kunden überspringen den Redirect.',
      url: 'Nutze eine vollständige URL mit Protokoll, z. B. https://app.example.com/welcome.',
      scope: 'Beim Deaktivieren wird die gespeicherte URL gelöscht.',
      verification: 'Nach E-Mail-Verifizierung wird zuerst diese URL genutzt; sonst fällt der Signup-Redirect (falls gesetzt) zurück.',
      verificationToggle: 'Aktiviere einen separaten Redirect nach der Verifizierung.',
      verificationUrl: 'Nutze eine vollständige URL inkl. Protokoll. Ein redirect_token wird angehängt.',
    },
    placeholders: {
      url: 'https://app.example.com/after-signup',
      verificationUrl: 'https://app.example.com/after-verification',
    },
    actions: {
      save: 'Redirect-Einstellungen speichern',
      saving: 'Speichere...',
      retry: 'Erneut versuchen',
    },
    messages: {
      saveSuccess: 'Signup-Redirect wurde aktualisiert.',
      saveError: 'Signup-Redirect konnte nicht gespeichert werden.',
      loadError: 'Signup-Redirect konnte nicht geladen werden.',
    },
    validation: {
      required: 'Eine Redirect-URL ist erforderlich, wenn der Redirect aktiviert ist.',
      url: 'Bitte eine gültige URL (inkl. https://) eingeben.',
      max: 'Die Redirect-URL darf höchstens 2048 Zeichen enthalten.',
    },
    sections: {
      signup: 'Redirect nach Signup',
      verification: 'Redirect nach Verifizierung',
    },
  },
  branding: {
    title: 'Branding',
    description: 'Passe das Branding auf kundenseitigen Seiten an.',
    fields: {
      active: 'Branding aktivieren',
      logoDarkUrl: 'Dunkles Logo (Light Mode)',
      logoLightUrl: 'Helles Logo (Dark Mode)',
      logoUrl: 'Fallback-Logo-URL',
      primaryColor: 'Primärfarbe',
      accentColor: 'Akzentfarbe',
    },
    helpers: {
      active: 'Wenn aktiv, werden Logo und Farben auf kundenseitigen Seiten verwendet.',
      logoDarkUrl: 'Wird auf hellen Hintergründen angezeigt.',
      logoLightUrl: 'Wird auf dunklen Hintergründen angezeigt.',
      logoUrl: 'Wird verwendet, wenn kein themespezifisches Logo hinterlegt ist.',
      primaryColor: 'Hex-Farbe für primäre Aktionen und Highlights.',
      accentColor: 'Hex-Farbe für sekundäre Aktionen und Akzente.',
    },
    placeholders: {
      logoDarkUrl: 'https://cdn.example.com/brand/logo-dark.png',
      logoLightUrl: 'https://cdn.example.com/brand/logo-light.png',
      logoUrl: 'https://cdn.example.com/brand/logo.png',
      primaryColor: '#0f172a',
      accentColor: '#22c55e',
    },
    validation: {
      logoTooLong: 'Die Logo-URL darf maximal 2048 Zeichen haben.',
      colorInvalid: 'Bitte eine gültige Hex-Farbe wie #0f172a eingeben.',
    },
    actions: {
      save: 'Branding speichern',
    },
    messages: {
      saveSuccess: 'Branding-Einstellungen gespeichert.',
      saveError: 'Branding-Einstellungen konnten nicht gespeichert werden.',
      loadError: 'Branding-Einstellungen konnten nicht geladen werden.',
    },
    preview: {
      title: 'Vorschau',
      description: 'Vorschau des Brandings.',
      lightLabel: 'Light Mode',
      darkLabel: 'Dark Mode',
      primary: 'Primär',
      accent: 'Akzent',
      logoAlt: '{{provider}}-Logo',
      urlPlaceholder: 'Provider-URL nicht verfügbar.',
      defaultName: 'Provider',
    },
  },
  terms: {
    title: 'Nutzungsbedingungen',
    description: 'Füge einen Link zu deinen Nutzungsbedingungen für Kund:innen-Flows hinzu.',
    helper: 'Verlinke auf die Nutzungsbedingungen deiner Website. Nur HTTPS; leer lassen, um zu deaktivieren.',
    loadError: 'Nutzungsbedingungen konnten nicht geladen werden.',
    saveSuccess: 'Link zu den Nutzungsbedingungen gespeichert.',
    saveError: 'Link zu den Nutzungsbedingungen konnte nicht gespeichert werden.',
    fields: {
      link: 'URL der Nutzungsbedingungen',
    },
    placeholders: {
      link: 'https://example.com/terms',
    },
    validation: {
      invalid: 'Bitte gib eine gültige HTTPS-URL ein.',
      tooLong: 'Der Link darf maximal 2048 Zeichen lang sein.',
    },
    actions: {
      save: 'Link speichern',
    },
  },
  customScripts: {
    title: 'Custom scripts',
    description: 'Füge benutzerdefiniertes HTML oder Skripte in jede Kunden- und Provider-Seite ein.',
    helper: 'Wird ohne Sanitizing in den Head eingefügt. Leer lassen, um zu entfernen.',
    fields: {
      script: 'Custom scripts',
    },
    placeholders: {
      script: "<script>console.log('custom')</script>",
    },
    actions: {
      save: 'Custom scripts speichern',
    },
    messages: {
      saveSuccess: 'Custom scripts gespeichert.',
      saveError: 'Custom scripts konnten nicht gespeichert werden.',
      loadError: 'Custom scripts konnten nicht geladen werden.',
    },
  },
  portalMenu: {
    title: 'Kundenportal-Menü',
    description: 'Füge benutzerdefinierte Links zur Kundenportal-Navigation hinzu.',
    helper: 'Links erscheinen in der Seitenleiste des Kundenportals. Nur http/https-URLs werden unterstützt.',
    hints: 'Niedrigere Reihenfolge-Zahlen erscheinen zuerst. Verwende Icon-Namen wie help-circle.',
    iconLibrary: 'Icon-Namen stammen von Lucide (lucide-react). Übersicht:',
    iconLibraryUrl: 'https://lucide.dev/icons',
    iconLibraryLinkLabel: 'lucide.dev/icons',
    empty: 'Noch keine Menüeinträge. Füge bis zu 20 Links hinzu.',
    itemTitle: 'Menüpunkt {{index}}',
    fields: {
      label: 'Label',
      url: 'URL',
      icon: 'Icon',
      order: 'Reihenfolge',
      target: 'Ziel',
    },
    placeholders: {
      label: 'Support',
      url: 'https://support.example.com',
      icon: 'help-circle',
      order: '10',
      target: 'In neuem Tab öffnen',
    },
    targets: {
      blank: 'In neuem Tab öffnen',
      self: 'Im selben Tab öffnen',
    },
    actions: {
      add: 'Menüeintrag hinzufügen',
      clear: 'Menü leeren',
      save: 'Menü speichern',
    },
    messages: {
      saveSuccess: 'Kundenportal-Menü gespeichert.',
      saveError: 'Kundenportal-Menü konnte nicht gespeichert werden.',
      loadError: 'Kundenportal-Menü konnte nicht geladen werden.',
    },
    validation: {
      maxItems: 'Du kannst bis zu 20 Menüeinträge hinzufügen.',
      labelRequired: 'Bitte ein Label eingeben.',
      labelTooLong: 'Das Label darf höchstens 80 Zeichen haben.',
      urlRequired: 'Bitte eine URL eingeben.',
      urlTooLong: 'Die URL darf höchstens 2048 Zeichen enthalten.',
      urlInvalid: 'Bitte eine gültige http(s)-URL eingeben.',
      iconTooLong: 'Das Icon darf höchstens 80 Zeichen haben.',
      orderRange: 'Die Reihenfolge muss zwischen 0 und 10000 liegen.',
      orderInteger: 'Die Reihenfolge muss eine ganze Zahl sein.',
    },
  },
  checkoutDomain: {
    title: 'Basis-Domain',
    description:
      'Gib eine Basis-Domain ein, um Checkout- und Auth-Subdomains zu erzeugen.',
    helper: 'Nur Host (kein https://, kein Pfad, kein Port). Basis-Domain eingeben.',
    helperDerived: 'Richte checkout.* und auth.* so ein, dass sie auf die Florentin-App zeigen.',
    helpers: {
      enabled: 'Aktiviert die benutzerdefinierten Checkout- und Auth-Subdomains.',
      dnsLinksLabel: 'DNS-Anleitungen:',
      cloudflare: 'Cloudflare',
      godaddy: 'GoDaddy',
      namecheap: 'Namecheap',
    },
    preview: {
      checkout: 'Checkout:',
      checkoutSuffix: '(Wir verwenden es für den Checkout)',
      auth: 'Auth:',
      authSuffix: '(Wir verwenden es für den Login)',
    },
    fields: {
      domain: 'Basis-Domain',
      enabled: 'Benutzerdefinierte Domains aktivieren',
    },
    placeholders: {
      domain: 'acme.com',
    },
    validation: {
      invalid: 'Bitte gib einen gültigen Host ein (kein Schema, kein Pfad, kein Port).',
      required: 'Bitte gib eine Basis-Domain ein, um benutzerdefinierte Domains zu aktivieren.',
      tooLong: 'Die Checkout-Domain darf höchstens 255 Zeichen lang sein.',
    },
    actions: {
      save: 'Checkout-Domain speichern',
    },
    messages: {
      saveSuccess: 'Checkout-Domain-Einstellungen aktualisiert.',
      saveError: 'Checkout-Domain-Einstellungen konnten nicht aktualisiert werden.',
      loadError: 'Checkout-Domain-Einstellungen konnten nicht geladen werden.',
    },
  },
  notificationSettings: {
    title: 'E-Mail-Benachrichtigungen',
    description: 'Konfiguriere Absenderdetails und BCC-Empfänger für ausgehende E-Mails.',
    sender: {
      title: 'Absenderdetails',
      helper: 'Wird im Feld "Von" der Kunden-E-Mails angezeigt.',
    },
    helper: 'Füge bis zu 10 BCC-Empfänger für OTPs, Einladungen, Verifizierungen und Abrechnungs-E-Mails hinzu.',
    hint: 'Drücke Enter oder Komma, um weitere Adressen hinzuzufügen.',
    empty: 'Noch keine BCC-Empfänger hinzugefügt.',
    loadError: 'Benachrichtigungseinstellungen konnten nicht geladen werden.',
    saveSuccess: 'Benachrichtigungseinstellungen gespeichert.',
    saveError: 'Benachrichtigungseinstellungen konnten nicht gespeichert werden.',
    count: '{{count}} / {{max}} hinzugefügt',
    fields: {
      fromName: 'Absendername',
      fromAddress: 'Absender-E-Mail',
      bcc: 'BCC-Empfänger',
    },
    placeholders: {
      fromName: 'Acme',
      fromAddress: 'no-reply@acme.com',
      bcc: 'audit@example.com',
    },
    validation: {
      invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      tooMany: 'Du kannst bis zu 10 BCC-Empfänger hinzufügen.',
      tooLong: 'E-Mail-Adressen dürfen höchstens 255 Zeichen lang sein.',
      nameTooLong: 'Der Absendername darf höchstens 255 Zeichen lang sein.',
      fromRequired: 'Bitte gib eine Absender-E-Mail ein.',
    },
    actions: {
      save: 'E-Mail-Einstellungen speichern',
    },
  },
  socialAuth: {
    title: 'Social-OAuth-Anbieter',
    description: 'Konfiguriere OAuth-Zugänge für Provider- und Kundenportale.',
    status: {
      disabled: 'Deaktiviert',
      valid: 'Validiert',
      invalid: 'Ungültig',
      pending: 'Nicht validiert',
      neverValidated: 'Noch nie validiert',
    },
    providers: {
      google: {
        name: 'Google',
        title: 'Google-Anmeldung',
        description: 'Erlaube Anmeldungen mit Google-Konten via OAuth 2.0.',
      },
      github: {
        name: 'GitHub',
        title: 'GitHub-OAuth-Apps',
        description: 'Nutze GitHub-OAuth-Apps zur Authentifizierung von Providern oder Kunden.',
      },
      apple: {
        name: 'Apple',
        title: 'Mit Apple anmelden',
        description: 'Richte Apple Services für „Mit Apple anmelden“ ein.',
      },
      azure: {
        name: 'Microsoft',
        title: 'Microsoft SSO',
        description: 'Aktiviere Microsoft Entra ID (Azure AD) für Provider- und Kundenportale.',
      },
    },
    fields: {
      enabled: 'Anbieter aktivieren',
      mode: {
        label: 'Umgebung',
        test: 'Testmodus',
        live: 'Live-Modus',
      },
      clientId: 'Client-ID',
      clientSecret: 'Client-Secret',
      teamId: 'Team-ID',
      keyId: 'Key-ID',
      privateKey: 'Privater Schlüssel',
      autoRotateSecret: 'Client-Secret automatisch rotieren',
      enterpriseHost: 'Enterprise-Host',
      orgWhitelist: 'Organisationen (Whitelist)',
      scopes: 'Scopes',
      prompt: 'Prompt',
      loginHint: 'Standard-Login-Hinweis',
      redirectOverride: 'Redirect-URI überschreiben',
    },
    placeholders: {
      clientId: 'Client-ID eingeben',
      clientSecret: 'Client-Secret eingeben',
      scopes: 'openid email profile',
      prompt: 'select_account',
      loginHint: 'user@example.com',
      redirectOverride: 'https://example.com/auth/oauth/callback',
      orgWhitelist: 'acme\nbeta-company',
    },
    helpers: {
      enabled: 'Deaktiviere den Anbieter, um ihn auf den Login-Seiten auszublenden.',
      mode: 'Nutze den Testmodus während der Integration; wechsle nach erfolgreicher Validierung auf Live.',
      clientSecret: 'Leer lassen, um das bestehende Secret beizubehalten.',
      privateKey: 'Füge den Inhalt der Apple-Private-Key-Datei (.p8) ein.',
      autoRotateSecret: 'Erzeugt automatisch neue Apple-Client-Secrets bevor sie ablaufen.',
      orgWhitelist: 'Eine Organisation pro Zeile. Nutzer müssen Mitglied der genannten Organisationen sein.',
      scopes: 'Durch Kommas oder Zeilenumbrüche trennen. Leer lassen für Standardscopes.',
      redirectOverride: 'Optional. Verwende eine eigene Redirect-URI falls abweichend.',
      redirectInfo: 'Nutze diese Redirect-URI in der Konfiguration deines Identitätsanbieters.',
      clientIdMasked: 'Aktuelle Client-ID: {{value}}',
    },
    labels: {
      lastValidated: 'Zuletzt validiert: {{date}}',
      currentRedirect: 'Aktuelle Redirect-URI',
      outstandingIssues: 'Offene Probleme',
      correlationId: 'Korrelations-ID: {{id}}',
    },
    actions: {
      save: 'Konfiguration speichern',
      validate: 'Zugangsdaten validieren',
      validating: 'Wird validiert...',
      test: 'Verbindung testen',
      testing: 'Test läuft...',
      delete: 'Konfiguration löschen',
      deleting: 'Löschen...',
      copyRedirect: 'Redirect kopieren',
    },
    statusBadges: {
      ready: 'Bereit',
    },
    messages: {
      saveSuccess: 'OAuth-Einstellungen wurden gespeichert.',
      saveError: 'OAuth-Einstellungen konnten nicht gespeichert werden.',
      validationSuccess: 'Zugangsdaten sind gültig.',
      validationError: 'Validierung fehlgeschlagen. Bitte überprüfe die Zugangsdaten.',
      testSuccess: 'Verbindungstest erfolgreich.',
      testError: 'Verbindungstest fehlgeschlagen.',
      deleteSuccess: 'Anbieter deaktiviert und Secrets entfernt.',
      deleteError: 'Anbieter konnte nicht deaktiviert werden.',
      confirmDelete: 'Möchtest du {{provider}} deaktivieren und alle Secrets löschen? Zur Reaktivierung müssen neue Zugangsdaten eingetragen werden.',
      copiedRedirect: 'Redirect-URI kopiert.',
      loadFailed: 'OAuth-Einstellungen konnten nicht geladen werden.',
      forbidden: 'Du besitzt keine Berechtigung für diese OAuth-Einstellungen. Prüfe Feature-Flags oder Benutzerrollen.',
      noProviders: 'Für diesen Mandanten sind keine OAuth-Anbieter verfügbar.',
    },
  },
  customerSync: {
    title: 'Integrationen',
    description: 'Verwalte den automatischen Export neu verifizierter Kunden zu externen Plattformen.',
    toggleLabel: 'Verifizierte Kunden an externe Plattform synchronisieren',
    toggleDescription:
      'Überträgt neu verifizierte Kunden automatisch an die angebundene Drittanbieter-Plattform.',
    enabledNote: 'Erfordert zuvor konfigurierte Integrations-Zugangsdaten.',
    addConfigFirst: 'Füge mindestens eine Integrationskonfiguration hinzu, bevor du die Synchronisierung aktivierst.',
    loadError: 'Synchronisierungs-Einstellungen konnten nicht geladen werden. Bitte später erneut versuchen.',
    configLoadError: 'Integrationskonfigurationen konnten nicht geladen werden. Bitte später erneut versuchen.',
    forbidden: 'Du hast keine Berechtigung, diese Synchronisierungs-Einstellungen zu verwalten.',
    saveSuccess: 'Sync-Präferenz aktualisiert.',
    saveError: 'Synchronisierungs-Einstellungen konnten nicht aktualisiert werden. Bitte erneut versuchen.',
    addConfig: 'Konfiguration hinzufügen',
    configsTitle: 'Integrationskonfigurationen',
    configsDescription: 'Verifizierte Kunden werden an jede aktivierte Konfiguration gesendet.',
    emptyTitle: 'Noch keine Integrationen konfiguriert',
    emptyDescription: 'Erstelle mindestens eine Webhook-Konfiguration, um die Synchronisierung zu aktivieren.',
    createDialogTitle: 'Integrationskonfiguration hinzufügen',
    editDialogTitle: 'Integrationskonfiguration bearbeiten',
    dialogDescription: 'Dieser Webhook wird ausgelöst, sobald ein neuer Kunde verifiziert wurde.',
    createDialogCta: 'Konfiguration erstellen',
    updateDialogCta: 'Änderungen speichern',
    createSuccess: 'Integrationskonfiguration erstellt.',
    updateSuccess: 'Integrationskonfiguration aktualisiert.',
    deleteTitle: 'Konfiguration löschen?',
    deleteDescription: 'An diesen Endpunkt werden keine verifizierten Kundendaten mehr gesendet.',
    confirmDelete: 'Konfiguration löschen',
    deleteSuccess: 'Konfiguration entfernt.',
    deleteError: 'Konfiguration konnte nicht gelöscht werden.',
    invalidJson: 'Bitte ein gültiges JSON-Objekt angeben.',
    timeoutRangeError: 'Timeout muss zwischen 1 und 120 Sekunden liegen.',
    status: {
      enabled: 'Aktiv',
      disabled: 'Inaktiv',
    },
    table: {
      name: 'Name',
      endpoint: 'Endpoint',
      method: 'Methode',
      status: 'Status',
      updated: 'Aktualisiert',
      actions: 'Aktionen',
      never: 'Nie',
    },
    form: {
      nameLabel: 'Name der Konfiguration',
      namePlaceholder: 'z. B. Kunden-Sync-Webhook',
      endpointLabel: 'Endpoint-URL',
      methodLabel: 'HTTP-Methode',
      timeoutLabel: 'Timeout (Sekunden)',
      timeoutDescription: 'Florentin bricht den Request ab, wenn innerhalb dieses Fensters keine Antwort erfolgt.',
      headersLabel: 'Header (JSON)',
      headersDescription: 'Optional. Ergänze zusätzliche Header wie Autorisierungs-Tokens.',
      payloadLabel: 'Payload-Vorlage (JSON)',
      payloadDescription:
        'Verwende {{email}}, {{first_name}}, {{last_name}} oder {{florentin_customer_id}}, um Felder zuzuordnen.',
      enabledLabel: 'Diese Konfiguration aktivieren',
      enabledDescription: 'Deaktivierte Konfigurationen bleiben gespeichert, erhalten aber keine Ereignisse.',
    },
  },
  webhooks: {
    title: 'Webhook-Endpunkte',
    description: 'Verwalte Webhook-Ziele und prüfe aktuelle Zustellversuche.',
    helper: 'Jeder aktive Endpunkt erhaelt die ausgewaehlten Events und kann mit einem Shared Secret signieren.',
    add: 'Webhook hinzufuegen',
    loadError: 'Webhook-Endpunkte konnten nicht geladen werden.',
    forbidden: 'Du hast keine Berechtigung, Webhooks zu verwalten.',
    emptyTitle: 'Noch keine Webhook-Endpunkte konfiguriert',
    emptyDescription: 'Erstelle mindestens einen Endpunkt, um Webhook-Events zu empfangen.',
    createDialogTitle: 'Webhook-Endpunkt hinzufuegen',
    editDialogTitle: 'Webhook-Endpunkt bearbeiten',
    dialogDescription: 'Lege fest, wohin Florentin die ausgewaehlten Webhook-Events sendet.',
    createDialogCta: 'Webhook erstellen',
    updateDialogCta: 'Aenderungen speichern',
    createSuccess: 'Webhook-Endpunkt erstellt.',
    updateSuccess: 'Webhook-Endpunkt aktualisiert.',
    saveError: 'Webhook-Endpunkt konnte nicht gespeichert werden.',
    deleteTitle: 'Diesen Webhook-Endpunkt loeschen?',
    deleteDescription: 'Zukuenftige Events werden nicht mehr an diese URL gesendet.',
    confirmDelete: 'Webhook loeschen',
    deleteSuccess: 'Webhook-Endpunkt entfernt.',
    deleteError: 'Webhook-Endpunkt konnte nicht geloescht werden.',
    viewDeliveries: 'Zustellungen anzeigen',
    hideDeliveries: 'Zustellungen ausblenden',
    status: {
      enabled: 'Aktiv',
      disabled: 'Inaktiv',
      secretConfigured: 'Secret konfiguriert',
      customHeadersConfigured: 'Custom Header',
    },
    table: {
      name: 'Name',
      url: 'Endpunkt-URL',
      events: 'Events',
      timeout: 'Timeout',
      status: 'Status',
      updated: 'Aktualisiert',
      actions: 'Aktionen',
      never: 'Nie',
      eventsCount: '{{count}} ausgewaehlt',
      timeoutSeconds: '{{count}}s',
    },
    form: {
      nameLabel: 'Name',
      namePlaceholder: 'Primaerer Endpunkt',
      urlLabel: 'Endpunkt-URL',
      secretLabel: 'Signatur-Secret',
      secretPlaceholder: 'Secret fuer Webhook-Signaturen eingeben',
      secretDescription: 'Optional. Leer lassen, um das aktuelle Secret bei Updates beizubehalten.',
      secretConfigured: 'Aktuell ist ein Secret konfiguriert.',
      clearSecretLabel: 'Gespeichertes Secret loeschen',
      clearSecretDescription: 'Wenn aktiviert, entfernt Florentin das aktuelle Secret fuer diesen Endpunkt.',
      headersLabel: 'Custom Header (JSON)',
      headersDescription: 'Optional. Fuege statische Header fuer ausgehende Requests hinzu (z. B. n8n Header Auth).',
      headersConfigured: 'Header-Werte sind aus Sicherheitsgruenden ausgeblendet. Gib neue Werte ein, um sie zu ersetzen.',
      headerKeys: 'Keys: {{keys}}',
      headersJsonError: 'Bitte ein gueltiges JSON-Objekt fuer Header eingeben.',
      clearHeadersLabel: 'Custom Header loeschen',
      clearHeadersDescription: 'Wenn aktiviert, entfernt Florentin alle gespeicherten Custom Header fuer diesen Endpunkt.',
      eventsLabel: 'Abonnierte Events',
      timeoutLabel: 'Timeout (Sekunden)',
      timeoutDescription: 'Requests werden abgebrochen, wenn innerhalb dieses Fensters keine Antwort eintrifft.',
      enabledLabel: 'Aktiv',
      enabledDescription: 'Deaktivierte Endpunkte bleiben gespeichert, erhalten aber keine Events.',
    },
    events: {
      'account.created': 'account.created',
      'user.login': 'user.login',
      'subscription.purchased': 'subscription.purchased',
      'invoice.created': 'invoice.created',
      'subscription.upgraded': 'subscription.upgraded',
      'subscription.downgraded': 'subscription.downgraded',
      'subscription.cancelled': 'subscription.cancelled',
      'team_member.added': 'team_member.added',
    },
    deliveryStatus: {
      pending: 'Ausstehend',
      processing: 'In Bearbeitung',
      succeeded: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
    },
    deliveries: {
      title: 'Letzte Zustellungen',
      loadError: 'Zustell-Logs konnten nicht geladen werden.',
      empty: 'Noch keine Zustellungen fuer diesen Endpunkt gefunden.',
      attempt: 'Versuch {{count}}',
      responseStatus: 'Response-Status',
      dispatchedAt: 'Gesendet am',
      deliveredAt: 'Zugestellt am',
      nextRetryAt: 'Naechster Retry',
      errorMessage: 'Fehlermeldung',
      responseBody: 'Response-Body',
      payload: 'Payload',
    },
  },
  externalPlanSelection: {
    title: 'Externe Partner-Plan-Auswahl',
    description:
      'Konfiguriere erlaubte Partner-Domains und das geteilte Secret für externe Plan-Auswahl-Anfragen.',
    loadError: 'Partner-Einstellungen konnten nicht geladen werden. Prüfe deine Sitzung oder versuche es später erneut.',
    saveSuccess: 'Partner-Einstellungen gespeichert.',
    saveError: 'Partner-Einstellungen konnten nicht aktualisiert werden. Bitte erneut versuchen.',
    rotateSuccess: 'Secret rotiert. Jetzt kopieren.',
    rotateError: 'Partner-Secret konnte nicht rotiert werden.',
    copySuccess: 'Secret kopiert.',
    copyError: 'Secret konnte nicht in die Zwischenablage kopiert werden.',
    secretOneTime: 'Kopiere jetzt das neue Shared Secret',
    copySecret: 'Secret kopieren',
    status: {
      actionNeeded: 'Partner-Endpunkt ist nicht bereit.',
      ready: 'Integration ist bereit',
      disabled: 'Integration ist deaktiviert. Aktiviere sie, um Partneranfragen anzunehmen.',
      missingSecret: 'Kein aktives Shared Secret gefunden. Rotiere, um ein neues Secret auszugeben.',
      healthy: 'Partner-Domain und Secret sind konfiguriert. Eingehende Partneranfragen werden akzeptiert.',
    },
    fields: {
      partnerName: 'Partnername',
      enabled: 'Partner-Integration aktivieren',
      allowedDomains: 'Erlaubte Domains',
      secretPreview: 'Secret-Vorschau',
      lastRotatedAt: 'Zuletzt rotiert',
    },
    helpers: {
      enabled: 'Wenn deaktiviert, werden Partneranfragen abgewiesen.',
      allowedDomains: 'Ein Hostname pro Zeile. Protokolle und Pfade werden automatisch entfernt.',
      secretPreview: 'Rotieren, um das vollständige Shared Secret zu sehen.',
      rotate: 'Nach dem Rotieren erhältst du das vollständige Secret sofort.',
    },
    placeholders: {
      partnerName: 'Acme Partner',
      allowedDomains: 'partner.example.com\\napi.partner.example.com',
    },
    validation: {
      partnerName: 'Partnername ist erforderlich.',
      allowedDomains: 'Bitte gültige Hostnamen ohne Protokolle oder Pfade eingeben.',
    },
    badges: {
      enabled: 'Aktiv',
      disabled: 'Inaktiv',
      secret: 'Shared Secret',
    },
    actions: {
      rotate: 'Secret rotieren',
      save: 'Änderungen speichern',
    },
    metrics: {
      title: 'Nutzung der externen Plan-Auswahl',
      totalIntents: 'Gesamtanfragen',
      fulfilledWithoutPayment: 'Ohne Zahlung erfüllt',
      pendingPayment: 'Zahlung ausstehend',
      completed: 'Abgeschlossen',
      lastIntentAt: 'Letzte Anfrage am',
    },
  },
  passwordAuth: {
    title: 'Passwort-Anmeldung (Provider)',
    customerTitle: 'Passwort-Anmeldung (Kunden)',
    description:
      'Erlaube Provider-Benutzern die Anmeldung mit E-Mail und Passwort zusätzlich zu Magic Links und OAuth-Anbietern.',
    providerDescription:
      'Ermöglicht Provider-Benutzern die Anmeldung mit E-Mail und Passwort zusätzlich zu Magic Links und Social Logins.',
    customerDescription:
      'Ermöglicht Kunden die Anmeldung im Kundenportal mit E-Mail und Passwort zusätzlich zu Magic Links.',
    enableLabel: 'Passwort-Anmeldung aktivieren',
    enableDescription: 'Blendet ein E-Mail- und Passwortformular auf der Provider-Loginseite ein.',
    customerEnableDescription: 'Blendet ein E-Mail- und Passwortformular auf der Kunden-Loginseite ein.',
    policyTitle: 'Passwort-Richtlinie',
    policyDescription: 'Definiere die Mindestanforderungen, die Passwörter erfüllen müssen.',
    minLengthLabel: 'Mindestlänge',
    historyLabel: 'Vorherige Passwörter sperren',
    historyDescription: 'Wie viele vorherige Passwörter nicht erneut verwendet werden dürfen.',
    requireNumbers: 'Zahlen erforderlich',
    requireNumbersDescription: 'Passwörter müssen mindestens eine Zahl enthalten.',
    requireSymbols: 'Sonderzeichen erforderlich',
    requireSymbolsDescription: 'Passwörter müssen mindestens ein Sonderzeichen enthalten.',
    requireMixedCase: 'Groß- und Kleinbuchstaben',
    requireMixedCaseDescription: 'Passwörter müssen Groß- und Kleinbuchstaben kombinieren.',
    policyDisabledHint: 'Die Richtlinie greift nur, wenn die Passwort-Anmeldung aktiv ist.',
    loadError: 'Passwort-Einstellungen konnten nicht geladen werden. Bitte Seite aktualisieren.',
    saveSuccess: 'Passwort-Anmeldung gespeichert.',
    saveError: 'Konfiguration konnte nicht gespeichert werden. Bitte versuche es erneut.',
    saving: 'Speichern…',
    saveCta: 'Konfiguration speichern',
    unauthorized:
      'Passwort-Einstellungen konnten mit dieser Sitzung nicht geladen werden. Hinterlege einen Provider-PAT über VITE_PROVIDER_AUTH_SETTINGS_TOKEN oder im lokalen Speicher unter florentin.provider.auth_settings_token.',
  },
  providerApi: {
    description: 'Erzeuge Service-Tokens, um Workflows zu automatisieren und sichere Portal-Links auszustellen.',
    summary: 'Tokens erben deine Provider-Berechtigungen. Teile sie nur mit vertrauenswürdigen Systemen.',
    securityNotice:
      'Behandle Tokens wie Passwörter. Rotiere sie regelmäßig, bewahre sie sicher auf und widerrufe kompromittierte Tokens sofort.',
    createToken: 'Service-Token erstellen',
    ssoConfigTitle: 'Standardwerte für Kunden-SSO',
    ssoConfigDescription: 'Diese Standardwerte gelten beim Erstellen von One-Click-Links für synchronisierte Kunden.',
    ssoDefaultTtl: 'Standard-Lebensdauer',
    minutes: '{{count}} Minute',
    minutes_plural: '{{count}} Minuten',
    ssoMaxTtl: 'Maximal erlaubter Override: {{count}} Minuten',
    ssoDomains: 'Erlaubte Redirect-Domains',
    noDomains: 'Keine Redirect-Domains konfiguriert. Links verwenden die primäre Provider-Domain.',
    ssoOverridesDisabled: 'Laufzeit-Overrides sind deaktiviert. Links nutzen immer die Standardwerte.',
    ssoConfigError: 'SSO-Konfiguration konnte nicht geladen werden. Token funktionieren dennoch.',
    tokensTitle: 'Service-Tokens',
    tokensDescription: 'Übersicht der ausgegebenen Tokens. Widerrufe ungenutzte Tokens zur Risikominimierung.',
    tokensError: 'Tokens konnten nicht geladen werden.',
    noTokens: 'Noch keine Service-Tokens vorhanden. Erstelle eines, um externe Automatisierungen zu aktivieren.',
    noTokensForScope: 'Für diesen Scope existieren keine Tokens.',
    scopeFilterLabel: 'Scope',
    scopeFilterAll: 'Alle Scopes',
    scopes: {
      ssoIssue: {
        label: 'Kunden-Portal-Links ausstellen',
        description: 'Ermöglicht das Erstellen von einmaligen SSO-Links für synchronisierte Kunden.',
      },
      providerAccess: {
        label: 'Provider-API-Zugriff',
        description: 'Gewährt automatisierten Zugriff auf die Provider-API-Endpunkte.',
      },
    },
    columns: {
      label: 'Bezeichnung',
      scopes: 'Scopes',
      created: 'Erstellt',
      lastUsed: 'Zuletzt verwendet',
      actions: 'Aktionen',
    },
    expiresLabel: 'Läuft ab am {{date}}',
    revoke: 'Widerrufen',
    revokeTitle: 'Token widerrufen?',
    revokeDescription:
      'Das Token wird sofort ungültig. Verbundene Systeme verlieren den Zugriff, bis ein neues Token erstellt wird.',
    revokeConfirm: 'Token widerrufen',
    revokeSuccess: 'Token wurde widerrufen.',
    revokeError: 'Token konnte nicht widerrufen werden.',
    restricted: 'Nur Provider-Admins können den API-Zugriff verwalten.',
    tokenForm: {
      title: 'Service-Token erstellen',
      subtitle: 'Der Tokenwert wird nur einmal angezeigt. Kopiere ihn und bewahre ihn sicher auf.',
      label: 'Bezeichnung',
      labelPlaceholder: 'z. B. Make-Zapier-Sync',
      labelTooShort: 'Die Bezeichnung muss mindestens 3 Zeichen lang sein.',
      labelTooLong: 'Die Bezeichnung darf maximal 120 Zeichen lang sein.',
      scopes: 'Scopes',
      scopesRequired: 'Wähle mindestens einen Scope aus.',
      notes: 'Interne Notiz',
      notesPlaceholder: 'Optional. Dokumentiere, wofür das Token verwendet oder gespeichert wird.',
      expiry: {
        label: 'Ablauf',
        never: 'Kein Ablauf (manuell widerrufen)',
        oneHour: '1 Stunde',
        oneDay: '24 Stunden',
        oneWeek: '7 Tage',
        thirtyDays: '30 Tage',
      },
      submit: 'Token erstellen',
      creating: 'Token wird erstellt…',
      creationError: 'Token konnte nicht erstellt werden.',
      copyAction: 'Token kopieren',
      copiedAction: 'Kopiert',
      copied: 'Token wurde in die Zwischenablage kopiert.',
      copyFailed: 'Token konnte nicht kopiert werden.',
      resultNotice: 'Kopiere den Token jetzt. Er wird nach Schließen des Dialogs nicht erneut angezeigt.',
      resultNoExpiry: 'Dieses Token läuft nicht automatisch ab.',
      resultExpiry: 'Läuft ab am {{date}}',
    },
    unavailable: 'Der Provider-API-Zugriff wird angezeigt, sobald die Backend-Endpoints aktiviert sind.',
    toggleNotice: 'Setze VITE_ENABLE_PROVIDER_API_TOKENS=true in der Provider-UI, sobald die API bereitsteht.',
  },
  checkoutContent: {
    title: 'Checkout-Messaging',
    description: 'Passen Sie Headline und Bullet-Points auf Ihrer Checkout-Seite an.',
    loadError: 'Checkout-Messaging konnte nicht geladen werden.',
    saveSuccess: 'Checkout-Messaging gespeichert.',
    saveError: 'Checkout-Messaging konnte nicht gespeichert werden.',
    fields: {
      headline: 'Headline',
      subheadline: 'Subheadline',
      bullet: 'Bullet',
    },
    helper: {
      headline: 'Wird als Haupttitel im Checkout angezeigt.',
      subheadline: 'Kurzer ergänzender Text unter der Headline.',
    },
    placeholders: {
      headline: 'Launch faster with confidence',
      subheadline: 'Everything you need to onboard and scale securely.',
      bullet1: 'Start building with a secure, fast API platform.',
      bullet2: 'Transparent pricing with predictable renewals.',
      bullet3: 'Priority support to help you launch faster.',
    },
    validation: {
      headlineTooLong: 'Headline darf maximal 120 Zeichen haben.',
      subheadlineTooLong: 'Subheadline darf maximal 200 Zeichen haben.',
      bulletTooLong: 'Bullets dürfen maximal 160 Zeichen haben.',
    },
    actions: {
      save: 'Messaging speichern',
    },
  },
  checkoutFields: {
    title: 'Checkout-Felder',
    description: 'Legen Sie fest, welche Felder im Checkout angezeigt und erforderlich sind.',
    helper: 'Ziehen Sie die Zeilen, um die Reihenfolge zu ändern.',
    columns: {
      field: 'Feld',
      enabled: 'Aktiv',
      required: 'Erforderlich',
      reorder: 'Sortieren',
    },
    fields: {
      company: 'Unternehmen',
      contact_phone: 'Telefonnummer',
      billing: {
        address_line_1: 'Rechnungsadresse Zeile 1',
        address_line_2: 'Rechnungsadresse Zeile 2',
        address_city: 'Ort (Rechnungsadresse)',
        address_state: 'Bundesland/Region (Rechnungsadresse)',
        address_postal_code: 'Postleitzahl (Rechnungsadresse)',
        address_country: 'Land (Rechnungsadresse)',
      },
    },
    actions: {
      save: 'Felder speichern',
    },
    messages: {
      saveSuccess: 'Checkout-Felder aktualisiert.',
      saveError: 'Checkout-Felder konnten nicht aktualisiert werden.',
      loadError: 'Checkout-Felder konnten nicht geladen werden.',
    },
  },
} as const;

export default settings;
